import RichText from '../RichText/RichText';

interface IFaqParagraphProps {
  title?: string;
  description?: string;
  className?: string;
}

export default function FaqParagraph({ title, description, className }: IFaqParagraphProps) {
  return (
    <div className={`tw-max-w-[1172px] tw-w-[85%] tw-mx-auto ${className}`}>
      <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-6 lg:tw-grid-cols-12 tw-gap-x-4 lg:tw-gap-x-6">
        <div className="tw-text-center tw-col-span-full">{title && <h2 className="tw-mt-0 tw-mb-0">{title}</h2>}</div>
        <div className="tw-col-span-full tw-mx-auto tw-max-w-[1172px]">
          {description && <RichText className="tw-mt-6" content={description} />}
        </div>
      </div>
    </div>
  );
}
